import { Typography } from "components/common";
import { WidthLinkText } from "components/parts/WithLinktext";
import {
  StyledAnnounceArea,
  StyledMegaphone,
  StyledContentArea,
  StyledTitleArea,
} from "components/report/ChatArea/AnnounceCard/styled";
import { newColors } from "constants/newColors";
import React from "react";

export type AnnounceCardProps = {
  text: string | null | undefined;
};

export const AnnounceCard: React.FC<AnnounceCardProps> = ({ text }) => {
  if (!text) return <></>;
  return (
    <StyledAnnounceArea>
      <StyledTitleArea>
        <StyledMegaphone />
        <Typography
          text="インタビュアーからのアナウンス"
          color={newColors.text}
          fontSize="medium"
          fontWeight="bold"
        />
      </StyledTitleArea>
      <StyledContentArea>
        <WidthLinkText
          text={text}
          textColor={newColors.text}
          fontSize="medium"
        />
      </StyledContentArea>
    </StyledAnnounceArea>
  );
};
